export default {
  verify: 'Verifizieren',
  visitor: 'Besucher',
  worker: 'Handwerker',
  name: 'Name',
  company: 'Firma',
  vistor_type: 'Art des Aufenthalts',
};
